import type { IndividualPart } from '@/types/rc/miners/PartType'
import { inject, provide, type InjectionKey, type Ref } from 'vue'

export interface IRepairSidebarContext {
  minerId: Ref<number>
  selectedPart: Ref<IndividualPart>
}

const repairsKey: InjectionKey<IRepairSidebarContext> = Symbol('repairs-context')

export function provideSidebarContext(sidebarContext: IRepairSidebarContext) {
  provide(repairsKey, sidebarContext)
}

export function useRepairsContext() {
  const context = inject(repairsKey)
  if (!context)
    throw new Error('useRepairsContext() must be used within a component that called provideRepairsContext()')
  return context
}
